import { defineStore } from "pinia";
import { ref } from "vue";

import { asReadonly } from "@/utils/vue";

type MenuPosition = "right" | "left";

export const useBoardMenuStore = defineStore("boardMenu", () => {
  const position = ref<MenuPosition>("left");
  const disabledShiftButton = ref(false);
  let defaultPosition: MenuPosition = "left";

  function toggleMenuPosition() {
    position.value = togglePosition(position.value);
    defaultPosition = position.value;
  }

  function setMenuPosition(pos: MenuPosition | "default") {
    if (pos === "default") {
      position.value = defaultPosition;
      disabledShiftButton.value = false;
    } else {
      position.value = pos;
      disabledShiftButton.value = true;
    }
  }

  return {
    disabledShiftButton: asReadonly(disabledShiftButton),
    position: asReadonly(position),

    toggleMenuPosition,
    setMenuPosition,
  };
});

function togglePosition(position: string) {
  return position === "left" ? "right" : "left";
}
